import {Component, HostBinding, Input, OnInit} from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-in-group-nfe-item',
  templateUrl: './in-group-nfe-item.component.html',
  styleUrls: ['./in-group-nfe-item.component.scss']
})
export class InGroupNfeItemComponent implements OnInit {

  @Input() nfe;
  @HostBinding('class.isOdd') @Input() isOdd;
  @HostBinding('class.danger-background') isBlocked: boolean;

  orderDate;
  nfeDate;

  constructor() { }

  ngOnInit(): void {
    if (this.nfe.status === 'BLOCKED') {
      this.isBlocked = true;
    }
    this.orderDate = moment(this.nfe.orderReceivedAt).format('DD/MM/YYYY - hh:mm');
    this.nfeDate = moment(this.nfe.receivedAt).format('DD/MM/YYYY - hh:mm');
  }

}
